"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip_types = exports.Title = exports.Text = exports.StyledTooltip = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("../../shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const TooltipStyles = (0, _styledComponents.css)(["font-family:", ";display:inline-block;position:absolute;text-align:left;width:160px;padding:8px;background:", ";border-radius:1px;color:white;visibility:", ";opacity:", ";z-index:", ";font-size:", ";line-height:", ";"], _shared.theme.typography.caption.fontFamily, _shared.theme.palette.brand.primary.charcoal, ({
  show
}) => show ? 'visible' : 'hidden', ({
  show
}) => show ? 1 : 0, _shared.theme.zIndex.tooltip, _shared.theme.typography.link.fontSize, _shared.theme.typography.kicker.lineHeight);
const TooltipTextStyle = (0, _styledComponents.css)(["font-family:", ";font-size:", ";line-height:", ";"], _shared.theme.typography.caption.fontFamily, _shared.theme.typography.caption.fontSize, _shared.theme.typography.caption.lineHeight);

const StyledBaseTooltip = _styledComponents.default.div.withConfig({
  displayName: "Tooltipstyles__StyledBaseTooltip",
  componentId: "sc-1qjrtrk-0"
})(["", " transition:all 0.2s ease-in-out;:before{content:'';position:absolute;width:0;height:0;border:6px solid transparent;z-index:", ";}"], TooltipStyles, _shared.theme.zIndex.tooltip);

const StyledTooltip = _styledComponents.default.div.attrs(({
  x,
  y
}) => ({
  style: {
    left: `${x}px`,
    top: `${y}px`
  }
})).withConfig({
  displayName: "Tooltipstyles__StyledTooltip",
  componentId: "sc-1qjrtrk-1"
})(["", " ", ";width:auto;padding:0 8px;white-space:nowrap;"], TooltipStyles, TooltipTextStyle);

exports.StyledTooltip = StyledTooltip;

const Title = _styledComponents.default.div.withConfig({
  displayName: "Tooltipstyles__Title",
  componentId: "sc-1qjrtrk-2"
})(["font-family:", ";font-size:", ";line-height:", ";text-transform:uppercase;letter-spacing:0.075em;margin-bottom:4px;"], _shared.theme.typography.kicker.fontFamily, _shared.theme.typography.kicker.fontSize, _shared.theme.typography.kicker.lineHeight);

exports.Title = Title;

const Text = _styledComponents.default.div.withConfig({
  displayName: "Tooltipstyles__Text",
  componentId: "sc-1qjrtrk-3"
})(["", ";"], TooltipTextStyle);

exports.Text = Text;
const StyledRightTooltip = (0, _styledComponents.default)(StyledBaseTooltip).withConfig({
  displayName: "Tooltipstyles__StyledRightTooltip",
  componentId: "sc-1qjrtrk-4"
})(["left:calc(100% + 12px);bottom:0;:before{left:-11px;bottom:8px;border-right-color:", ";}"], _shared.theme.palette.brand.primary.charcoal);
const StyledBottomTooltip = (0, _styledComponents.default)(StyledBaseTooltip).withConfig({
  displayName: "Tooltipstyles__StyledBottomTooltip",
  componentId: "sc-1qjrtrk-5"
})(["top:calc(100% + 12px);right:0;:before{right:8px;top:-11px;border-bottom-color:", ";}"], _shared.theme.palette.brand.primary.charcoal);
const StyledLeftTooltip = (0, _styledComponents.default)(StyledBaseTooltip).withConfig({
  displayName: "Tooltipstyles__StyledLeftTooltip",
  componentId: "sc-1qjrtrk-6"
})(["right:calc(100% + 12px);bottom:0;:before{bottom:8px;right:-11px;border-left-color:#121313;}"]);
const StyledTopTooltip = (0, _styledComponents.default)(StyledBaseTooltip).withConfig({
  displayName: "Tooltipstyles__StyledTopTooltip",
  componentId: "sc-1qjrtrk-7"
})(["bottom:calc(100% + 12px);right:0;:before{right:8px;bottom:-11px;border-top-color:#121313;}"]);
const Tooltip_types = {
  right: StyledRightTooltip,
  bottom: StyledBottomTooltip,
  left: StyledLeftTooltip,
  top: StyledTopTooltip
};
exports.Tooltip_types = Tooltip_types;